import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import Auth from '../Components/auth';

function Cto() {

    const [tableData, setTabledata] = useState([]);
    const [isData, setData] = useState(false);

    const Api = process.env.REACT_APP_API_URL

    const getDirectUser = () => {

        //  console.log('https://rainocoin.com/api/directUser.php?userid='+localStorage.getItem('id'))
        fetch(Api + 'directUser.php?userid=' + localStorage.getItem('id'))
            .then(res => res.json())
            .then(
                (downline) => {

                    console.log("My Referral " + downline.error);

                    if (downline.error === "200") {

                        //console.log(downline);

                        setTabledata(downline.data)

                        setData(true)

                    } else {
                        setData(false)
                    };

                    if (downline.error === "400") {
                        setData(false)

                    };
                }
            )
    }

    useEffect(() => {

        getDirectUser();

    }, [])

    return (
        <div>
            <Auth />
            <div className="header is-fixed">
                <div className="tf-container">
                    <div className="tf-statusbar d-flex justify-content-center align-items-center">
                        <Link to="/" className="back-btn"> <i className="icon-left" /> </Link>
                        <h3>CTO Rewars</h3>
                    </div>
                </div>
            </div>
            <div id="app-wrap">
                <div className="app-section st1 mt-1 mb-5 bg_white_color">
                    <div className="tf-container">
                        <div className="trading-month">
                            <div className="group-trading-history mb-5">
                                {isData ?
                                    <div>
                                        {/* {tableData.map(item =>(
                                <Link className="tf-trading-history" to="javascript:void(0)">
                                    <div className="inner-left">
                                        <div className="icon-box">
                                            <i className="icon icon-mobile" />
                                        </div>
                                        <div className="content">
                                            <h4>{item.name}</h4>
                                            <p>{item.joidDate +' '+item.joinTime}</p>
                                        </div>
                                    </div>
                                    <span className="num-val success_color ">{item.accountStatus}</span>
                                </Link>
                                ))} */}
                                    </div>

                                    :
                                    <div>
                                        <Link className="tf-trading-history" to="javascript:void(0)">
                                            <div className="inner-left">
                                                <div className="icon-box">
                                                    <i className="icon icon-mobile" />
                                                </div>
                                                <div className="content">
                                                    <h4>No Any Data</h4>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Footer */}
            <div className="bottom-navigation-bar">
                <div className="tf-container">
                    <ul className="tf-navigation-bar">
                        <li>
                            <Link className="fw_4 d-flex justify-content-center align-items-center flex-column" to="/"><i className="icon-home" /> Home</Link>
                        </li>
                        <li className="active"><Link className="fw_4 d-flex justify-content-center align-items-center flex-column" to="/history"><i className="icon-history" /> History</Link> </li>
                        <li><Link className="fw_4 d-flex justify-content-center align-items-center flex-column" to="/qr-code"><i className="icon-scan-qr-code" /> </Link> </li>
                        <li><Link className="fw_4 d-flex justify-content-center align-items-center flex-column" to="/rewards"><svg width={25} height={24} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12.25" cy={12} r="9.5" stroke="#717171" />
                            <path d="M17.033 11.5318C17.2298 11.3316 17.2993 11.0377 17.2144 10.7646C17.1293 10.4914 16.9076 10.2964 16.6353 10.255L14.214 9.88781C14.1109 9.87213 14.0218 9.80462 13.9758 9.70702L12.8933 7.41717C12.7717 7.15989 12.525 7 12.2501 7C11.9754 7 11.7287 7.15989 11.6071 7.41717L10.5244 9.70723C10.4784 9.80483 10.3891 9.87234 10.286 9.88802L7.86469 10.2552C7.59257 10.2964 7.3707 10.4916 7.2856 10.7648C7.2007 11.038 7.27018 11.3318 7.46702 11.532L9.2189 13.3144C9.29359 13.3905 9.32783 13.5 9.31021 13.607L8.89692 16.1239C8.86027 16.3454 8.91594 16.5609 9.0533 16.7308C9.26676 16.9956 9.6394 17.0763 9.93735 16.9128L12.1027 15.7244C12.1932 15.6749 12.3072 15.6753 12.3975 15.7244L14.563 16.9128C14.6684 16.9707 14.7807 17 14.8966 17C15.1083 17 15.3089 16.9018 15.4469 16.7308C15.5845 16.5609 15.6399 16.345 15.6033 16.1239L15.1898 13.607C15.1722 13.4998 15.2064 13.3905 15.2811 13.3144L17.033 11.5318Z" stroke="#717171" strokeWidth="1.25" />
                        </svg>
                            Rewards</Link> </li>
                        <li><Link className="fw_4 d-flex justify-content-center align-items-center flex-column" to="/profile"><i className="icon-user-outline" /> Profile</Link> </li>
                    </ul>
                    {/* <span class="line"></span> */}
                </div>
            </div>
            {/* <Footer/> */}
            <div className="tf-panel up">
                <div className="panel-box panel-up panel-filter-history">

                    <div id="app-wrap" className="style1">
                        <div className="mt-6">
                            <div className="tf-container">
                                <h4 className="mt-3 mb-3">Monthly</h4>
                                <ul className="filter-history">
                                    <li><Link to="#" className="tf-btn large active">All</Link></li>
                                    <li><Link to="#" className="tf-btn large">Jan</Link></li>
                                    <li><Link to="#" className="tf-btn large">Feb</Link></li>
                                    <li><Link to="#" className="tf-btn large">Mar</Link></li>
                                    <li><Link to="#" className="tf-btn large">Apr</Link></li>
                                    <li><Link to="#" className="tf-btn large">May</Link></li>
                                    <li><Link to="#" className="tf-btn large">Jun</Link></li>
                                    <li><Link to="#" className="tf-btn large">July</Link></li>
                                    <li><Link to="#" className="tf-btn large">Aug</Link></li>
                                    <li><Link to="#" className="tf-btn large">Sep</Link></li>
                                    <li><Link to="#" className="tf-btn large">Oct</Link></li>
                                    <li><Link to="#" className="tf-btn large">Nov</Link></li>
                                    <li><Link to="#" className="tf-btn large">Dec</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="mt-1">
                            <div className="container">
                                <h4 className="mt-3 mb-3">Status</h4>
                                <ul className="filter-history status">
                                    <li><Link to="#" className="tf-btn large active">All</Link></li>
                                    <li><Link to="#" className="tf-btn large">Successful</Link></li>
                                    <li><Link to="#" className="tf-btn large">Processing</Link></li>
                                    <li><Link to="#" className="tf-btn large">Failure</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="box-btn">
                            <div className="tf-container">
                                <Link to="61_filter-research.html" className="tf-btn accent large">Apply</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Cto